import { actionCreator } from '@ardoq/rxbeach';

export const bypassLimitAction = actionCreator('[component tree] BYPASS_LIMIT');
